<template>
    <div>
        <p class="mx-auto text-primary text-center font-weight-bold">ایجاد حساب کاربری</p>
        <p class="text-small text-center text-grey-darken-1">برای استفاده از سامانه نیاز است تا یک حساب کاربری برای خود ایجاد نمایید.</p>
        <p v-if="username_type == 'username' && $system.systemSettings.username_example" class="text-small text-center text-grey-darken-1">مثال نام کاربری: {{$system.systemSettings.username_example}}</p>
        <v-form class="mt-5" ref="form" @submit.prevent="$refs.form?.isValid && !invalidPassword && submit()">
            <v-row dense>
                <v-col>
                    <v-text-field
                        :rules="$validation('required')"
                        label="* نام"
                        v-model="form.first_name"
                    ></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field
                        :rules="$validation('required')"
                        label="* نام خانوادگی"
                        v-model="form.last_name"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-text-field
                :rules="$validation(['required', 'email'])"
                v-if="username_type == 'email'"
                append-inner-icon="icon-user"
                label="* ایمیل"
                v-model="form.email"
                style="min-width: 300px;"
            ></v-text-field>
            <v-text-field
                :rules="$validation('required')"
                v-if="username_type == 'mobile'"
                append-inner-icon="icon-user"
                label="* موبایل"
                v-model="form.mobile"
                style="min-width: 300px;"
            ></v-text-field>
            <v-text-field
                :rules="$validation(['required', ($system.systemSettings.username_regex ? 'regex:' + $system.systemSettings.username_regex : false)].filter(Boolean))"
                v-if="username_type == 'username'"
                append-inner-icon="icon-user"
                :label="`* نام کاربری${$system.systemSettings.username_example ? ' (مثال: ' + $system.systemSettings.username_example + ')' : ''}`"
                v-model="form.username"
                style="min-width: 300px;"
            ></v-text-field>
            <template v-if="$system.systemSettings.authenticate_customers_type != 'otp'">
                <p v-if="$system.systemSettings.force_users_using_secure_password" class="text-small text-grey-darken-1 mb-2 text-justify">کلمه عبور می‌باید دارای حداقل 8 کاراکتر شامل حروف کوچک و بزرگ انگلیسی و اعداد باشد.</p>
                <v-text-field
                    :error="invalidPassword"
                    :append-inner-icon="pass1 ? 'visibility' : 'visibility_off'"
                    :type="pass1 ? 'password' : 'text'"
                    @click:appendInner="() => {pass1 = !pass1;}"
                    hide-details
                    label="* کلمه عبور"
                    v-model="password"
                ></v-text-field>
                <v-progress-linear
                    :bg-color="`${passwordStrengthColor[passwordStrength]}30`"
                    :color="passwordStrengthColor[passwordStrength]"
                    :model-value="passwordStrength*25"
                    class="mb-4 mt-1 rounded"
                ></v-progress-linear>
            </template>
            <v-btn :loading="loading" class="mx-auto mt-1 mb-3 d-block" width="180" color="primary" type="submit">
                <v-icon class="pe-2" size="17">icon-useradd</v-icon>
                <p class="text-small text-white">ايجاد حساب کاربری جدید</p>
            </v-btn>
            <div class="text-center" v-if="$system.systemSettings.signup_from_customers_permission">
                <v-btn @click="$router.push({path: '/login'})" width="180" variant="text" color="secondary" class="text-small">ورود به حساب کاربری</v-btn>
            </div>
        </v-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                first_name: null,
                last_name: null,
                email: null,
                mobile: null,
                username: null,
            },
            password: null,
            username_type: this.$system.systemSettings.username_type,
            pass1: true,
            passwordStrengthColor: [
                "#777777",
                "#ef2f2e",
                "#fe8025",
                "#fedb41",
                "#10bb67",
            ],
        };
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        passwordStrength() {
            return Number(/[a-z]/.test(this.password)) +
            Number(/[A-Z]/.test(this.password)) +
            Number(/[0-9]/.test(this.password)) +
            Number(this.password?.length >= 8);
        },
        invalidPassword() {
            return this.$system.systemSettings.authenticate_customers_type != 'otp' && this.$system.systemSettings.force_users_using_secure_password && this.passwordStrength != 4;
        },
    },
    methods: {
        submit() {
            let form = {
                first_name: this.form.first_name,
                last_name: this.form.last_name,
                [this.username_type]: this.form[this.username_type]
            }
            if (this.$system.systemSettings.authenticate_customers_type != 'otp')
                form.password = this.password;
            this.$emit('submited', form);
        }
    }
};
</script>
